/** Модуль состояния всплывашки с ошибками */
let _errId = Number.MIN_SAFE_INTEGER
const getErrId = () => _errId++

export default {
  namespaced: true,
  state: {
    errors: [],
  },
  actions: {
    showError: ({ state, commit }, { message, duration = 8000, preventDupes = true }) => {
      if (preventDupes) {
        state.errors
          .filter(e => e.message === message)
          .forEach(({ id }) => commit('hideError', { id }))
      }
      const id = getErrId()
      commit('_addError', { id, message })
      if (duration) {
        setTimeout(() => commit('hideError', { id }), duration)
      }
    },
  },
  mutations: {
    _addError: (state, { id, message }) =>
      state.errors.push({ id, message }),
    hideError: (state, { id }) => {
      state.errors = state.errors.filter(e => e.id !== id)
    },
    close: (state) => { state.errors = [] },
  },
}
